import { DATA_TABLE_SOURCE_AGENT_LEADS } from 'common/dataTableConstants';

import makeInitialState from 'client/makeInitialState';
import { actionDataTableReset } from 'client/helpers/dataTables';

export default async function resetLeadsTable({ state }) {
  actionDataTableReset({ state }, { dataSource: DATA_TABLE_SOURCE_AGENT_LEADS });
  state.set(
    ['apartmentLocator', 'leadsByStatus'],
    makeInitialState().apartmentLocator.leadsByStatus,
  );
  state.commit();
}
